import { call, put, takeLatest, select } from "redux-saga/effects";
import * as actions from "./actions";
import { FETCHING_INVOICE_LIST, DOWNLOAD_INVOICE_LIST } from "./types";
import {
  searchInvoiceListRequestSelector,
  searchInvoiceListRequestWithoutePagingSelector,
  isFiltersAppliedSelector
} from "./selectors";
import { setRequestInProcess } from "../request/actions";
import invoicesApiService from "../../services/invoicesApiService";
import { invoiceGridDataAdaptor } from "../../utils/invoiceAdaptors";
import { downloadBase64AsFile } from "../../utils/fileHelpers";
import { getNoDataType, addDataToErrors, dateAdapter } from "../../utils/helpers";
import { showModal } from "../modal/actions";
import modalNames from "../../constants/modalNames";

function* fetchInvoiceListAsync() {
  try {
    yield put(setRequestInProcess(FETCHING_INVOICE_LIST, true));

    const request = yield select(searchInvoiceListRequestSelector);

    const response = yield call(x => invoicesApiService.searchInvoices(x), dateAdapter(request));

    if (response.hasError) {
      yield put(actions.fetchingInvoiceListError(response.errors));
      yield put(
        showModal(modalNames.ERROR_MODAL, {
          errors: addDataToErrors(response.errors, { helpDeskEmail: process.env.REACT_APP_HELP_DESK_EMAIL })
        })
      );
    } else {
      const invoices = response.payload.content.map(i => invoiceGridDataAdaptor(i));
      const isFiltersApplied = yield select(isFiltersAppliedSelector);
      const total = response.payload.totalElements;
      const noDataType = getNoDataType(total, isFiltersApplied);

      yield put(actions.fetchingInvoiceListSuccess({ invoices, total, noDataType }));
    }
  } catch (err) {
    yield put(actions.fetchingInvoiceListError([err.message]));
    // eslint-disable-next-line no-console
    console.error(err);
  } finally {
    yield put(setRequestInProcess(FETCHING_INVOICE_LIST, false));
  }
}

function* watchFetchInvoiceListAsync() {
  yield takeLatest(FETCHING_INVOICE_LIST, fetchInvoiceListAsync);
}

function* downloadInvoiceListAsync(action) {
  try {
    yield put(setRequestInProcess(DOWNLOAD_INVOICE_LIST, true));

    const { lang, reportFormat } = action.payload;

    const request = yield select(searchInvoiceListRequestWithoutePagingSelector);
    request.lang = lang;
    request.reportFormat = reportFormat;

    const response = yield call(x => invoicesApiService.downloadInvoices(x), dateAdapter(request));

    yield put(setRequestInProcess(DOWNLOAD_INVOICE_LIST, false));

    if (response.hasError) {
      yield put(showModal(modalNames.ERROR_MODAL, { errors: response.errors }));
      yield put(actions.downloadInvoiceListError(response.errors));
    } else {
      const { fileName, data } = response.payload;
      if (fileName && data) {
        downloadBase64AsFile(data, fileName, `application/${reportFormat}`);
      }
      yield put(actions.downloadInvoiceListSuccess());
    }
  } catch (err) {
    yield put(actions.downloadInvoiceListError([err.message]));
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function* watchDownloadInvoiceListAsync() {
  yield takeLatest(DOWNLOAD_INVOICE_LIST, downloadInvoiceListAsync);
}

export { watchFetchInvoiceListAsync, watchDownloadInvoiceListAsync };
